import { Nullable } from '../../types/common'
import BaseComponent from '../base-component/base-component'
import Cart from './cart'

class CartDrawerButtonsBlock extends BaseComponent {
  cartDrawer: Nullable<Cart>

  constructor() {
    super()

    this.cartDrawer = this.closest('cart-drawer')
  }

  connectedCallback(): void {
    if (this.cartDrawer) {
      this.cartDrawer.subscribe('start-update', this.handleStartCartUpdate)
      this.cartDrawer.subscribe('update-nodes', this.handleFinishCartUpdate)
    }
  }

  disconnectedCallback(): void {
    if (this.cartDrawer) {
      this.cartDrawer.unsubscribe('start-update', this.handleStartCartUpdate)
      this.cartDrawer.unsubscribe('update-nodes', this.handleFinishCartUpdate)
    }
  }

  handleStartCartUpdate = (): void => {
    this.setLoading(true)
  }

  handleFinishCartUpdate = (): void => {
    this.setLoading(false)
  }

  setLoading(isLoading: boolean): void {
    const button = this.querySelector('[data-cart-checkout-button]')

    if (!button) {
      return
    }

    button.toggleAttribute('disabled', isLoading)
    button.classList.toggle('loading', isLoading)
  }
}

export default CartDrawerButtonsBlock
